import React from 'react';
import '../css/menubms.css'
import { bmsMenuImgHorizontal, bmsMenuImgVertical, paciente_icon, medico_icon, bmsLogo } from '../components/Images';
import { Link } from 'react-router-dom';
import { APPROVAL_FOOTER } from '../config/lrApproval';

const BMSMenuPage = () => {
    
    return (
        <div className="patient-content">
            <div className="menu-header">
                <img src={bmsMenuImgHorizontal} id="img-h" alt="Encabezado" className="menu-image" />
                <img src={bmsMenuImgVertical} id="img-v" alt="Encabezado" className="menu-image" />
            </div>
            <div className='inner-bar'>
                <hr className="bar" />
            </div>
            <div className='menu-content'>
                <div className='headings'>
                    <h1>Vamos <span className='highligted-text'>Contigo</span></h1>
                    <h2>Programa Soporte a <span className='highligted-text'>Pacientes</span></h2>
                </div>
                <hr className="divider" />
                <div className='headings'>
                    <h3>Bienvenido</h3>
                </div>
                <div className='menu-buttons'>
                    <div className='menu-btn-container'>
                        <div className='menu-btn-icon'>
                            <img src={paciente_icon} alt="" className='img-icon' />
                        </div>
                        <Link className='qr-menu-btn' to={"/qrPatientForm"} >
                            Paciente
                        </Link>
                    </div>
                    <div className='menu-btn-container'>
                        <div className='menu-btn-icon'>
                            <img src={medico_icon} alt="" className='img-icon' />
                        </div>
                        <Link className='qr-menu-btn' to={process.env.REACT_APP_PSP_LATAM_APP}>
                            Médico
                        </Link>
                    </div>
                </div>
            </div>
            <div className="patient-content-footer">
            <div className='footer-content'>
                <div className='footer-text'>
                    <div>Material dirigido a médicos</div>
                    <div>{APPROVAL_FOOTER}</div>
                </div>
                <div className="footer-logo">
                    <img src={bmsLogo}  alt="" />
                </div>
            </div>
            
            <hr className="footer-bar" />
        </div>
        </div>
    );
}

export default BMSMenuPage;
